export default __webpack_public_path__ + "static/media/presentation.bad2a3e3.pptx";